import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export function ScrollToTop() {
  const { pathname, search, hash } = useLocation()

  useEffect(() => {
    // Se a navegação for para uma âncora específica (#secao), rolar suave para o elemento
    if (hash) {
      try {
        const element = document.querySelector(hash)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' })
          return
        }
      } catch {
        // Ignora seletores inválidos
      }
    }

    const resetAllScrolls = () => {
      // Reset imediato de rolagem da janela (window)
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'instant'
      })

      // Garantir reset dos elementos raiz do documento
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0

      // Resetar containers com scroll interno
      const scrollableContainers = document.querySelectorAll<HTMLElement>('[class*="publicContainer"], [class*="mainContent"], [class*="content"]')
      scrollableContainers.forEach((container) => {
        container.scrollTop = 0
      })
    }

    resetAllScrolls()

    // Timeout de segurança após a renderização dos componentes na rota
    const timer = setTimeout(resetAllScrolls, 50)
    return () => clearTimeout(timer)
  }, [pathname, search, hash])

  return null
}
